module.exports = __webpack_public_path__ + "img/img-cropper.60b39a05.jpg";